import { TOTALS_LOAN_VALUE_CUSTOM_KEY } from 'pages/Waterfall/SpreadsheetConfig/FundSummarySheetConfig/WaterfallFundSummaryParser/WaterfallFundSummaryParser.constants';
import { WaterfallFundSummaryColumn } from './useWaterfallFundSummarySheetConfig.types';

export const WATERFALL_FUND_SUMMARY_SHEET_NAME = 'waterfallFundSummary';

// Cross-sheet handle other sheets use to read the firm's loan total.
export const FIRM_TOTAL_LOAN_VALUE_REFERENCE = `${WATERFALL_FUND_SUMMARY_SHEET_NAME}.${TOTALS_LOAN_VALUE_CUSTOM_KEY}`;

export const LOAN_VALUE_COLUMN: WaterfallFundSummaryColumn = { key: 'loanValue', label: 'Loan Value' };

const WATERFALL_FUND_SUMMARY_BASE_COLUMNS: WaterfallFundSummaryColumn[] = [
  { key: 'entity', label: 'Entity' },
  { key: 'exitProceeds', label: 'Exit Proceeds' },
];

const WATERFALL_FUND_SUMMARY_TAIL_COLUMNS: WaterfallFundSummaryColumn[] = [
  { key: 'previousProceeds', label: 'Previous Proceeds' },
  { key: 'investedCapital', label: 'Invested Capital' },
  { key: 'moic', label: 'MOIC' },
  { key: 'irr', label: 'IRR' },
];

export const WATERFALL_FUND_SUMMARY_COLUMNS = [
  ...WATERFALL_FUND_SUMMARY_BASE_COLUMNS,
  ...WATERFALL_FUND_SUMMARY_TAIL_COLUMNS,
];

export const WATERFALL_FUND_SUMMARY_COLUMNS_WITH_LOAN = [
  ...WATERFALL_FUND_SUMMARY_BASE_COLUMNS,
  LOAN_VALUE_COLUMN,
  ...WATERFALL_FUND_SUMMARY_TAIL_COLUMNS,
];
